import { render, staticRenderFns } from "./CoozzySidebarNav.vue?vue&type=template&id=32ae085f&scoped=true"
import script from "./CoozzySidebarNav.vue?vue&type=script&lang=js"
export * from "./CoozzySidebarNav.vue?vue&type=script&lang=js"
import style0 from "./CoozzySidebarNav.vue?vue&type=style&index=0&id=32ae085f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae085f",
  null
  
)

export default component.exports